const StrateNouveauSliderTemoignages = {

    init() {
        const strate = $('#strate-nouveau-slider-temoignages');

        if (strate) {
            const sliderItemParent = $('#strate-nouveau-slider-temoignages .bottom_slider .slider');
            // const sliderItems = sliderItemParent.find('.slide_temoignage');

            /*
            if (sliderItems.length > 1) {
                StrateNouveauSliderTemoignages.build(sliderItemParent, sliderItems);
            }*/
        }
    },
    
    updateSliderWrapperDimension(sliderWrapper, sliderItems) {
        if (sliderItems.length === 3) {
            if (screen.width >= 480 && screen.width < 1024) {
                sliderWrapper.css('max-width', '85vw');
            } else {
                sliderWrapper.css('max-width', 'unset');
            }
        }
    },

    build(sliderWrapper, sliderItems) {
        sliderWrapper.addClass('owl-carousel');

        const onInitialize = () => {
            StrateNouveauSliderTemoignages.updateSliderWrapperDimension(sliderWrapper, sliderItems);
        };

        const onResize = () => {
            StrateNouveauSliderTemoignages.updateSliderWrapperDimension(sliderWrapper, sliderItems);
            sliderWrapper.trigger('refresh.owl.carousel');
        };

        sliderWrapper.owlCarousel(
            {
                center: false,
                margin: 20,
                items: 1,
                loop: false,
                nav: false,
                dots: true,
                stagePadding: 0,
                autoWidth: false,
                responsive: {
                    768: {
                        center: false,
                        margin: 20,
                        items: 2,
                        loop: false,
                        nav: false,
                        dots: true,
                        stagePadding: 0,
                        autoWidth: false,
                    },
                    1024: {
                        center: false,
                        margin: 20,
                        items: 3,
                        loop: false,
                        nav: false,
                        dots: true,
                        stagePadding: 0,
                        autoWidth: false,
                    },
                },
                onInitialize,
                onResize,
            }
        );
    },
};

export default StrateNouveauSliderTemoignages;
